import { createSelector } from 'reselect';
import { RootState } from 'state/store';
import { UsersState } from './user-identities.slice';

export const selectUserIdentitiesState = (state: RootState): UsersState => state.userIdentities;
export const selectUserIdentitiesData = createSelector(selectUserIdentitiesState, (state) => state.data);
